import React, { Component } from 'react';
import { connect }          from 'react-redux';
import { Link }            from 'react-router-dom';
import moment               from 'moment';
import icone                from '../../../img/icon/brain.svg';
import registro             from "../../../img/global/registro.png";
import chave                from "../../../img/desafios/box-desafio-chave.png";
import quiz                 from "../../../img/desafios/box-desafio-quiz.png";
import bomba                from "../../../img/desafios/box-desafio-bomba.png";
class desafios_lista extends Component {

    renderListDesafios(){

       
        const dados = this.props.allAtividadesLista.filter(elem => (this.props.checkSelect == null ? elem.status === 1 || elem.status === 5 || elem.status === 6 : elem.status ===2 || elem.status ===3 || elem.status ===4));
        if (dados.length>0) {

            return  dados.map((elem,i)=>{
               
                var img = "";
                const cursor = {'cursor':'default'}
                switch (elem.ati_tipo) {                   
                    case this.props.menu.desafios.jogo.tipo1:    
                    var img = chave;
                    break;
                    case this.props.menu.desafios.jogo.tipo2:      
                      var img = bomba;
                    break;
                    case this.props.menu.desafios.jogo.tipo3:    
                    var img = quiz;
                    break;
                    default:
                    break;
                }

                const listaDados =  
                                    <div>
                                        <div className="retangulo">
                                            <div className="retangulo-item">
                                                <div className="text"><span>{elem.ati_titulo}</span></div>
                                            </div>
                                            <div className="linha"></div>
                                        </div>
                                        <div className="hexagon">
                                            <div className="hexagon-item"><div className="text"><p>{moment(elem.ati_data_fim).format("DD/MM")}</p></div></div>
                                            <div className="hexagon-item"><img src={img} /></div>
                                            <div className="hexagon-item"><p>{`${elem.tentativas_jogadas}/${elem.ati_qtd_tentativas}`}</p></div>
                                        </div>
                                        <div className="retangulo">
                                            <div className="linha"></div>
                                            <div className="retangulo-item direito">
                                                <div className="text"><span>{elem.dis_nome}</span></div>
                                            </div>
                                        </div>
                                    </div>;
               return  (elem.status ===1 ?
                        <Link to={`${this.props.menu.desafios.jogos}/${elem.ati_id}/${elem.ati_tipo}`} className="lista-desafios-container" key={i}>
                            {listaDados}
                        </Link> :
                        <div className="lista-desafios-container" style={cursor} key={i}>
                            {listaDados}
                        </div>
                        );
            });
            
        } else {
            const margin = {"margin": "0 auto"}
           return <img src={registro} style={margin} className="img-responsive" alt=""/>;
        }
    }

    render(){
        return(
            <div className="lista-desafios">
               {this.renderListDesafios()}
            </div>
        );
    }
}

function mapStateToProps(state) {

    return { 
            session : state.auth.session,
            checkSelect     : state.scopoReducer.checkSelect,
            allAtividadesLista : state.atividadesReducer.allAtividadesLista,
            menu    : state.configReducer.menu
           }
}

export default connect(mapStateToProps)(desafios_lista);



// WEBPACK FOOTER //
// ./src/components/aluno/desafios/desafios_lista.js